import { ENTITY_STATUS, NEWSPAPER_ACTION, SOURCE } from 'constants/status';

export const MOCK_NEWSPAPERS = [
  {
    id: 'np-1',
    type: 'newspaper',
    newspaper_name: 'Divya Bhaskar',
    editions: ['Ahmedabad', 'Surat', 'Rajkot'],
    action: NEWSPAPER_ACTION.KEYWORD_SEARCH,
    keywords: ['ગિરનાર', 'જૈન', 'budget'],
    sources: [SOURCE.TELEGRAM, SOURCE.EPAPER_PDF, SOURCE.MANUAL],
    status: ENTITY_STATUS.ACTIVE,
    created_at: '2026-01-10T06:00:00Z',
  },
  {
    id: 'np-2',
    type: 'newspaper',
    newspaper_name: 'Gujarat Samachar',
    editions: ['Ahmedabad', 'Vadodara', 'Bhavnagar'],
    action: NEWSPAPER_ACTION.KEYWORD_SEARCH,
    keywords: ['election', 'મેટ્રો'],
    sources: [SOURCE.EPAPER_PDF, SOURCE.WHATSAPP],
    status: ENTITY_STATUS.ACTIVE,
    created_at: '2026-01-12T06:00:00Z',
  },
  {
    id: 'np-3',
    type: 'newspaper',
    newspaper_name: 'Sandesh',
    editions: ['Ahmedabad', 'Junagadh'],
    action: NEWSPAPER_ACTION.OCR_UPLOAD,
    keywords: [],
    sources: [SOURCE.EPAPER_CHAT, SOURCE.MANUAL],
    status: ENTITY_STATUS.ACTIVE,
    created_at: '2026-02-01T06:00:00Z',
  },
  {
    id: 'np-4',
    type: 'newspaper',
    newspaper_name: 'Dainik Jagran',
    editions: ['Delhi', 'Lucknow', 'Kanpur'],
    action: NEWSPAPER_ACTION.KEYWORD_SEARCH,
    keywords: ['चुनाव', 'बजट'],
    sources: [SOURCE.TELEGRAM, SOURCE.EPAPER_PDF],
    status: ENTITY_STATUS.INACTIVE,
    created_at: '2026-02-08T06:00:00Z',
  },
  {
    id: 'np-5',
    type: 'newspaper',
    newspaper_name: 'Mid-Day',
    editions: ['Mumbai'],
    action: NEWSPAPER_ACTION.OCR_UPLOAD,
    keywords: [],
    sources: [SOURCE.EPAPER_PDF, SOURCE.MANUAL],
    status: ENTITY_STATUS.ACTIVE,
    created_at: '2026-03-02T06:00:00Z',
  },
];

export default MOCK_NEWSPAPERS;
